export default __webpack_public_path__ + "static/media/joke-teller.86b078b5.png";